// Resolve username from user object

export const getUserName = user => {
	if (!user) {
		return 'No user';
	}

	const { firstname, lastname, fullName } = user;

	if (firstname && lastname) {
		return `${firstname} ${lastname}`;
	}
	if (fullName) {
		return fullName;
	}
	if (firstname) {
		return firstname;
	}
	else if (lastname) {
		return lastname;
	}
	return 'Un-named user';
};

